import React from 'react';
import BoothItem from './BoothItem';
import { withRouter } from 'react-router-dom';
import './Booth.css';
import CloseIcon from '@material-ui/icons/Close';
import { Grid, Fab, Paper, withStyles, IconButton } from '@material-ui/core';
import { EVENT_IMG, EVENT_FOLDER } from '../constants';
import { ImHome } from 'react-icons/im';
// import swal from 'sweetalert';

const styles = (theme) => ({
  bg: {
    //backgroundImage: `url('/images/ksc2021/ksc_main.jpg')`,
    height: 'calc(100vh - 88px)',
    backgroundRepeat: 'no-repeat',
    backgroundSize: '100%',
    backgroundPosition: '0 -80px',
    overflowY: 'hidden',
    alignItems: 'center',
    [theme.breakpoints.down('md')]: {
      alignItems: 'baseline',
      backgroundImage: 'none',
      height: 'calc(100vh - 175px)',
    },
  },
  modalExhibition: {
    width: '1289px',
    //height: '80vh',
    position: 'relative',
    zIndex: '111',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    [theme.breakpoints.down('md')]: {
      width: '80vw',
      margin: '5vh 0',
    },
  },
  closeBtn: {
    color: '#fff',
    textAlign: 'right',
    [theme.breakpoints.down('sm')]: {
      display: 'none',
    },
  },
  outerStatellites: {
    width: '100%',
    height: '726px',
    overflowY: 'auto',

    [theme.breakpoints.down('sm')]: {
      overflowY: 'hidden',
    },

    backgroundColor: 'white',
    padding: '10px',
    [theme.breakpoints.down('lg')]: {
      height: '70vh',
    },
  },
  webExhibi: {
    width: '100%',
    display: 'block',

    [theme.breakpoints.down('sm')]: {
      display: 'none',
    },
  },
  mobExhibi: {
    width: '100%',
    display: 'none',
    padding: '0 2vw',
    // backgroundColor: '#777',
    backgroundColor: '#025a3c',
    [theme.breakpoints.down('sm')]: {
      display: 'block',
      paddingBottom: 150,
    },
  },
  gradeName: {
    border: '2px solid black',
    width: '100%',
    padding: '5px',
    fontSize: 17,
    fontWeight: 'bold',
    borderRadius: 4,
    marginTop: 20,
    '&:nth-child(1)': {
      marginTop: 0,
    },
  },
});

class Booth extends React.Component {
  constructor(props) {
    super(props);
    this.goToPage = this.goToPage.bind(this);
    this.state = {
      matches: window.matchMedia('(max-width:960px)').matches,
    };
  }
  goToPage(_move) {
    this.props.history.push(_move);
  }

  mapToComponent(datas) {
    // return datas.map((satellite, i) => {
    //   return <BoothItem key={i} satellite={satellite} satellites={this.props.datas} emitBoothVisit={this.props.emitBoothVisit} />;
    // });

    // **custom 웹 부스 등급별
    return (
      <>
        <div className={'diamond'}>
          <Grid container style={{ height: '100%' }} justifyContent="center" alignItems="center">
            {datas
              .filter((el) => el.grade === 'diamond')
              .map((satellite, i) => {
                return (
                  <Grid item xs={12}>
                    <BoothItem
                      key={`web_diamond_${i}`}
                      satellite={satellite}
                      satellites={this.props.datas}
                      emitBoothVisit={this.props.emitBoothVisit}
                    />
                  </Grid>
                );
              })}
          </Grid>
        </div>

        <div className={'platinum'}>
          <Grid container style={{ height: '100%' }} justifyContent="center" alignItems="center">
            {datas
              .filter((el) => el.grade === 'platinum')
              .map((satellite, i) => {
                return (
                  <Grid item xs={12}>
                    <BoothItem
                      key={`web_platinum_${i}`}
                      satellite={satellite}
                      satellites={this.props.datas}
                      emitBoothVisit={this.props.emitBoothVisit}
                    />
                  </Grid>
                );
              })}
          </Grid>
        </div>

        <div className={'gold'}>
          <Grid container style={{ height: '100%' }} justifyContent="center" alignItems="center">
            {datas
              .filter((el) => el.grade === 'gold')
              .map((satellite, i) => {
                return (
                  <Grid item xs={12}>
                    <BoothItem
                      key={`web_gold_${i}`}
                      satellite={satellite}
                      satellites={this.props.datas}
                      emitBoothVisit={this.props.emitBoothVisit}
                    />
                  </Grid>
                );
              })}
          </Grid>
        </div>

        <div className={'silver'}>
          <Grid container style={{ height: '100%' }} justifyContent="center" alignItems="center">
            {datas
              .filter((el) => el.grade === 'silver')
              .map((satellite, i) => {
                return (
                  <Grid item xs={12}>
                    <BoothItem
                      key={`web_silver_${i}`}
                      satellite={satellite}
                      satellites={this.props.datas}
                      emitBoothVisit={this.props.emitBoothVisit}
                    />
                  </Grid>
                );
              })}
          </Grid>
        </div>

        <div className={'standard'}>
          <Grid container style={{ height: '100%' }} justifyContent="center" alignItems="center">
            {datas
              .filter((el) => el.grade === 'standard')
              .map((satellite, i) => {
                return (
                  <Grid item xs={3}>
                    <BoothItem
                      key={`web_standard_${i}`}
                      satellite={satellite}
                      satellites={this.props.datas}
                      emitBoothVisit={this.props.emitBoothVisit}
                    />
                  </Grid>
                );
              })}
          </Grid>
        </div>
      </>
    );
  }

  renderMobBoothItem(datas) {
    return (
      <>
        <p
          className={this.props.classes.gradeName}
          style={{ borderColor: '#00A8EE', color: '#00A8EE', backgroundColor: '#fff', textAlign: 'center', fontSize: 'large' }}
        >
          DIAMOND
        </p>
        <Grid container>
          {datas
            .filter((el) => el.grade === 'diamond')
            .map((satellite, i) => {
              return (
                <Grid item xs={6}>
                  <BoothItem
                    key={`diamond_${i}`}
                    satellite={satellite}
                    satellites={this.props.datas}
                    emitBoothVisit={this.props.emitBoothVisit}
                  />
                </Grid>
              );
            })}
        </Grid>
        <p
          className={this.props.classes.gradeName}
          style={{
            borderColor: 'rgb(207,154,239)',
            color: 'rgb(207,154,239)',
            backgroundColor: '#fff',
            textAlign: 'center',
            fontSize: 'large',
          }}
        >
          PLATINUM
        </p>
        <Grid container>
          {datas
            .filter((el) => el.grade === 'platinum')
            .map((satellite, i) => {
              return (
                <Grid item xs={6}>
                  <BoothItem
                    key={`platinum_${i}`}
                    satellite={satellite}
                    satellites={this.props.datas}
                    emitBoothVisit={this.props.emitBoothVisit}
                  />
                </Grid>
              );
            })}
        </Grid>

        <p
          className={this.props.classes.gradeName}
          style={{ borderColor: '#FFD700', color: '#FFD700', backgroundColor: '#fff', textAlign: 'center', fontSize: 'large' }}
        >
          GOLD
        </p>
        <Grid container>
          {datas
            .filter((el) => el.grade === 'gold')
            .map((satellite, i) => {
              return (
                <Grid item xs={6}>
                  <BoothItem
                    key={`gold_${i}`}
                    satellite={satellite}
                    satellites={this.props.datas}
                    emitBoothVisit={this.props.emitBoothVisit}
                  />
                </Grid>
              );
            })}
        </Grid>
        <p
          className={this.props.classes.gradeName}
          style={{ borderColor: '#8F8F8F', color: '#8F8F8F', backgroundColor: '#fff', textAlign: 'center', fontSize: 'large' }}
        >
          SILVER
        </p>
        <Grid container>
          {datas
            .filter((el) => el.grade === 'silver')
            .map((satellite, i) => {
              return (
                <Grid item xs={6}>
                  <BoothItem
                    key={`silver_${i}`}
                    satellite={satellite}
                    satellites={this.props.datas}
                    emitBoothVisit={this.props.emitBoothVisit}
                  />
                </Grid>
              );
            })}
        </Grid>
        <p
          className={this.props.classes.gradeName}
          style={{ borderColor: '#C49C48', color: '#C49C48', backgroundColor: '#fff', textAlign: 'center', fontSize: 'large' }}
        >
          STANDARD
        </p>
        <Grid container>
          {datas
            .filter((el) => el.grade === 'standard')
            .map((satellite, i) => {
              return (
                <Grid item xs={4}>
                  <BoothItem
                    key={`standard_${i}`}
                    satellite={satellite}
                    satellites={this.props.datas}
                    emitBoothVisit={this.props.emitBoothVisit}
                  />
                </Grid>
              );
            })}
        </Grid>
      </>
    );
  }
  render() {
    const { classes } = this.props;

    return (
      <div className={classes.bg} style={{ display: 'flex', justifyContent: 'center', overflowY: 'auto' }}>
        <Grid className={classes.webExhibi} container justifyContent="center" style={{ position: 'relative', overflowX: 'hidden' }}>
          <img style={{ width: '100%', display: 'block' }} src={`${EVENT_IMG}/exhibition_bg.jpg`} alt={''} />
          <div className="acc_flag">
            <Grid
              container
              justifyContent="center"
              alignItems="center"
              alignContent="center"
              item
              xs={12}
              style={{ height: '100%', position: 'relative' }}
              onClick={() => window.open(`https://www.acc.org/acccentralasia`, '_blank')}
            >
              <Fab
                style={{
                  position: 'absolute',
                  top: 0,
                  right: 0,
                  height: 40,
                  width: 40,
                  backgroundColor: '#fff',
                  border: '1px solid #de3e36',
                }}
              >
                <ImHome size={20} className={'gif_style'} />
              </Fab>
            </Grid>
          </div>
          {/* <div className="acc">
            <Grid
              container
              justifyContent="center"
              alignItems="center"
              alignContent="center"
              item
              xs={12}
              style={{ cursor: 'pointer', height: '100%', position: 'relative', borderRadius: '5px' }}
              // onClick={() => swal('', 'acc site Link', '')}
            >
              <img
                src={`https://innon.s3.ap-northeast-2.amazonaws.com/${EVENT_FOLDER}/logo/logo_000.png`}
                alt={'img'}
                style={{
                  width: '90%',
                  backgroundColor: '#fff',
                  border: '2px solid',
                  borderColor: this.props.theme.palette.primary.main,
                  borderRadius: '5px',
                }}
              />
            </Grid>
          </div> */}
          {this.mapToComponent(this.props.datas)}
        </Grid>

        {/* 모바일 */}
        <div className={classes.mobExhibi}>
          <div
            style={{
              backgroundColor: '#efefef',
              margin: '4vh 0',
              borderRadius: '4px',
              padding: '10px',
            }}
          >
            <div
              style={{
                color: this.props.theme.palette.primary.point,
                fontSize: '26px',
                padding: '15px 0',
                fontWeight: 'bold',
                textAlign: 'center',
                display: this.state.matches ? 'block' : 'none',
              }}
            >
              Exhibition
            </div>

            {this.renderMobBoothItem(this.props.datas)}
          </div>
          <Grid container justifyContent="center" className={classes.cardGridMob}>
            <Paper
              elevation={1}
              onClick={() => {
                // this.openBoothDialog(this.props.satellite, data);
              }}
              // onClick={() => this.visitUpdate(data)}
              style={{ display: 'flex', borderRadius: '10px', margin: '5px 0 ', cursor: 'pointer' }}
              // className={classes.cardMob}
            >
              <Grid
                container
                justifyContent="center"
                alignItems="center"
                alignContent="center"
                style={{ height: this.state.matches ? 'auto' : '100%' }}
                onClick={() => window.open(`https://www.acc.org/acccentralasia`, '_blank')}
              >
                <img
                  style={{ width: '95%', height: 'auto' }}
                  src={`https://innon.s3.ap-northeast-2.amazonaws.com/${EVENT_FOLDER}/logo/logo_000.png`}
                  alt={'img'}
                />
              </Grid>
            </Paper>
          </Grid>
        </div>

        <div className={classes.modalExhibition} style={{ display: 'none' }}>
          <div style={{ width: '100%', textAlign: 'right' }} className={classes.closeBtn}>
            <IconButton
              style={{ color: '#ffffff' }}
              onClick={() => {
                this.props.history.push('main');
              }}
            >
              <CloseIcon />
            </IconButton>
          </div>
          <div style={{ borderRadius: '5px', width: '100%', overflow: 'hidden' }}>
            <div className={classes.outerStatellites}>
              <div
                style={{
                  color: this.props.theme.palette.primary.point,
                  fontSize: '26px',
                  padding: '15px 0',
                  fontWeight: 'bold',
                  textAlign: 'center',
                  display: this.state.matches ? 'block' : 'none',
                }}
              >
                Exhibition
              </div>
              <div
                className="satellites"
                style={
                  this.state.matches
                    ? {
                        height: '55vh',
                        overflowY: 'auto',
                      }
                    : {}
                }
              >
                {/* 웹 */}
                {/* <div className={classes.webExhibi}>
                  <Grid container justifyContent="center">
                    {this.mapToComponent(this.props.datas.slice(0, 1), 'diamond')}
                  </Grid>
                  <Grid container justifyContent="center">
                    {this.mapToComponent(this.props.datas.slice(2, 7), 'platinum')}
                  </Grid>
                  <Grid container justifyContent="center">
                    {this.mapToComponent(this.props.datas.slice(8, 14), 'gold')}
                  </Grid>
                  <Grid container justifyContent="center">
                    {this.mapToComponent(this.props.datas.slice(15, 18), 'silver')}
                  </Grid>
                  <Grid container justifyContent="center">
                    {this.mapToComponent(this.props.datas.slice(12, 25), 'standard')}
                  </Grid>
                </div> */}

                {/* 모바일 */}
                {/* <div className={classes.mobExhibi}>{this.mapToComponent(this.props.datas)}</div> */}
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default withRouter(withStyles(styles, { withTheme: true })(Booth));
